module.exports = __webpack_public_path__ + "static/media/Condiciones de Uso.20488dde.pdf";